import { combineReducers } from 'redux';

import {
  setOpenDocumentPageInstructionModal,
  setDocumentPageInstructionId,
  setInlineDocumentPageInstruction,
} from '../../actions';
import { ScriptEditorAction, DocumentPageInstructionState } from '../../types';
import { Reducer } from '../../../../types';
import documents from './documents';
import documentPages from './documentPages';

type ReducerOf<T extends keyof DocumentPageInstructionState> = Reducer<DocumentPageInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenDocumentPageInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setDocumentPageInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};
const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineDocumentPageInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

const currentPage: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineDocumentPageInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
  documents,
  documentPages,
  currentPage,
});
